import { useEffect, useState } from "react";
import { dds } from "./ddsClient";

/**
 * Observable DDS WebSocket connection state, from @aelive/dds-client's
 * connection API (OPUS-1440).
 *
 * Once adopted this also replaces useFixtureData's useTabResync guesswork,
 * which fires a full 281-key refetch whenever a tab regains focus — including
 * on a perfectly healthy connection that was merely hidden.
 *
 * Returns null when the client has no WS transport, so callers can no-op.
 */
export function useDDSConnection() {
  const [state, setState] = useState(() => dds?.connection?.getState?.() || null);
  useEffect(() => {
    const conn = dds?.connection;
    if (!conn?.subscribe) return undefined;
    return conn.subscribe(setState);
  }, []);
  return state;
}

export const reconnectDDS = () => dds?.connection?.reconnectNow?.();
